import {Context, createContext} from 'react';
import FilterStepsStore from './filter-steps-store';

const FilterStepsContext: Context<any> = createContext(FilterStepsStore);

export default FilterStepsContext;